import { render, staticRenderFns } from "./postTransactionCustomerInfo.vue?vue&type=template&id=70381d3b&scoped=true"
import script from "./postTransactionCustomerInfo.vue?vue&type=script&lang=js"
export * from "./postTransactionCustomerInfo.vue?vue&type=script&lang=js"
import style0 from "./postTransactionCustomerInfo.vue?vue&type=style&index=0&id=70381d3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70381d3b",
  null
  
)

export default component.exports